/*
 * File: /src/store/modules/formFieldProfiles.js
 * Created Date: Saturday March 16th 2019
 * Author: Nicolas Wegener
 * -----
 * Last Modified: Sunday, 17th March 2019 4:19:09 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import FormFieldProfileService from 'src/services/formFieldProfileService';

const state = {
  formFieldProfiles: undefined
};

const getters = {
  getFormFieldProfiles: (state) => {
    return state.formFieldProfiles;
  },
};
const actions = {
  async fetchFormFieldProfiles({ commit, state }) {
    // Only load the data once
    if (state.formFieldProfiles == undefined) {
      return FormFieldProfileService.fetchAll()
      .then(r => {
        commit('setFormFieldProfiles', sortProfiles(r.data));
      });
    }
  },
  // Allow reloading the state when changed.
  // Consider doing this on other store components to react to updates at least locally
  async reloadFormFieldProfiles({ commit }) {
    const r = await FormFieldProfileService.fetchAll();
    commit('setFormFieldProfiles', sortProfiles(r.data));
    return r.data;
  },
  unloadFormFieldProfiles({ commit }) {
    commit('setFormFieldProfiles', undefined);
  }
};

// Sort one time rather that on each component using it
const sortProfiles = (profiles) => {
  if (!Array.isArray(profiles)) {
    return [];
  }
  return profiles.slice().sort((first, second) => {
    const firstOrder = first.display_order ?? 0;
    const secondOrder = second.display_order ?? 0;
    if (firstOrder != secondOrder) {
      return firstOrder - secondOrder;
    }
    return String(first.label || '').localeCompare(String(second.label || ''));
  });
};

const mutations = {
  setFormFieldProfiles(state, profiles) {
    state.formFieldProfiles = profiles;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
